import { Injectable, InjectionToken } from '@angular/core';
import { Converter } from '@spartacus/core';

@Injectable({ providedIn: 'root' })
export class PascalToCamelCaseNormalizer implements Converter<PlainObject, PlainObject> {
  convert(source: PlainObject): PlainObject {
    const result: PlainObject = source instanceof Array ? [] : {};

    for (const key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        const resultKey = typeof key === 'string' ? key[0].toLowerCase().concat(key.substring(1)) : key;

        if (typeof source[key] === 'object') {
          result[resultKey] = this.convert(source[key]);
        } else {
          result[resultKey] = source[key];
        }
      }
    }

    return result;
  }
}

export const PASCAL_TO_CAMEL_CASE_NORMALIZER = new InjectionToken<PascalToCamelCaseNormalizer>(
  'PascalToCamelCaseNormalizer',
);
